import React from 'react';
import { Col, } from 'react-bootstrap';

export default function Buttons({ children, align, group, className, }) {
  return (
    <div className={`text-${align || 'start'} ${className || ''}`}>
      <Col xs={12} className={`d-none d-sm-block${group ? ' btn-group' : ''}`}>
        {children}
      </Col>
      <Col xs={12} className="d-block d-sm-none d-grid gap-2 mb-2">
        {children}
      </Col>
    </div>
  );
}
